import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import {
  getHomeIntroAdmin, updateHomeIntro,
  getWhyChooseAdmin, updateWhyChoose,
  getInfoCardsAdmin, updateInfoCard, addInfoCard, deleteInfoCard,
} from '../../services/adminService';
import { uploadToCloudinary } from '../../utils/uploadToCloudinary';

function IntroSection() {
  const [data, setData] = useState({ heading: '', paragraph: '' });
  const [saving, setSaving] = useState(false);
  useEffect(() => { getHomeIntroAdmin().then(setData); }, []);
  const save = async (e) => { e.preventDefault(); setSaving(true); await updateHomeIntro(data); setSaving(false); alert('Saved!'); };
  return (
    <div className="admin-section">
      <div className="admin-section-header"><h2>Home Intro Text</h2></div>
      <div className="admin-section-body">
        <form className="admin-form" onSubmit={save} style={{ maxWidth: 600 }}>
          <div><label>Heading</label><input value={data.heading} onChange={e => setData(d => ({ ...d, heading: e.target.value }))} /></div>
          <div><label>Paragraph</label><textarea rows={4} value={data.paragraph} onChange={e => setData(d => ({ ...d, paragraph: e.target.value }))} /></div>
          <div><button className="a-btn a-btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button></div>
        </form>
      </div>
    </div>
  );
}

function WhyChooseSection() {
  const [data, setData] = useState({ image: '', points: [] });
  const [newPoint, setNewPoint] = useState('');
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  useEffect(() => { getWhyChooseAdmin().then(setData); }, []);

  const handleImg = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try { const url = await uploadToCloudinary(file); setData(d => ({ ...d, image: url })); }
    catch { alert('Upload failed'); }
    finally { setUploading(false); }
  };

  const addPoint = () => { if (!newPoint.trim()) return; setData(d => ({ ...d, points: [...d.points, newPoint.trim()] })); setNewPoint(''); };
  const removePoint = (i) => setData(d => ({ ...d, points: d.points.filter((_, idx) => idx !== i) }));
  const save = async (e) => { e.preventDefault(); setSaving(true); await updateWhyChoose(data); setSaving(false); alert('Saved!'); };

  return (
    <div className="admin-section">
      <div className="admin-section-header"><h2>Why Choose Us</h2></div>
      <div className="admin-section-body">
        <form className="admin-form" onSubmit={save} style={{ maxWidth: 600 }}>
          <div><label>Image</label>
            <label className="upload-box">
              <input type="file" accept="image/*" onChange={handleImg} />
              {uploading ? <p>Uploading…</p> : data.image ? <img src={data.image} alt="" style={{ maxHeight: 80 }} /> : <p>Click to upload</p>}
            </label>
          </div>
          <div>
            <label>Points</label>
            {data.points.map((pt, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
                <input value={pt} onChange={e => setData(d => ({ ...d, points: d.points.map((p, idx) => idx === i ? e.target.value : p) }))} style={{ flex: 1 }} />
                <button type="button" className="a-btn a-btn-sm a-btn-danger" onClick={() => removePoint(i)}>✕</button>
              </div>
            ))}
            <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
              <input value={newPoint} onChange={e => setNewPoint(e.target.value)} placeholder="Add new point…" style={{ flex: 1 }} />
              <button type="button" className="a-btn a-btn-sm a-btn-accent" onClick={addPoint}>+ Add</button>
            </div>
          </div>
          <div><button className="a-btn a-btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button></div>
        </form>
      </div>
    </div>
  );
}

function InfoCardsSection() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editCard, setEditCard] = useState(null);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  const load = () => getInfoCardsAdmin().then(d => { setCards(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleImg = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try { const url = await uploadToCloudinary(file); setEditCard(c => ({ ...c, img: url })); }
    catch { alert('Upload failed'); }
    finally { setUploading(false); }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    if (editCard.id) {
      await updateInfoCard(editCard.id, { img: editCard.img, title: editCard.title, desc: editCard.desc, link: editCard.link });
    } else {
      await addInfoCard({ img: editCard.img, title: editCard.title, desc: editCard.desc, link: editCard.link, order: cards.length });
    }
    setEditCard(null);
    await load();
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete card?')) return;
    await deleteInfoCard(id);
    setCards(p => p.filter(c => c.id !== id));
  };

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <h2>Info Cards</h2>
        <button className="a-btn a-btn-accent" onClick={() => setEditCard({ img: '', title: '', desc: '', link: '' })}>+ Add Card</button>
      </div>
      <div className="admin-section-body">
        {editCard && (
          <form className="admin-form" onSubmit={handleSave} style={{ maxWidth: 500, marginBottom: 24, padding: 16, background: 'var(--a-bg)', borderRadius: 8 }}>
            <div><label>Image</label>
              <label className="upload-box">
                <input type="file" accept="image/*" onChange={handleImg} />
                {uploading ? <p>Uploading…</p> : editCard.img ? <img src={editCard.img} alt="" style={{ maxHeight: 60 }} /> : <p>Click to upload</p>}
              </label>
            </div>
            <div><label>Title</label><input value={editCard.title} onChange={e => setEditCard(c => ({ ...c, title: e.target.value }))} required /></div>
            <div><label>Description</label><textarea rows={2} value={editCard.desc} onChange={e => setEditCard(c => ({ ...c, desc: e.target.value }))} /></div>
            <div><label>Link (URL)</label><input value={editCard.link} onChange={e => setEditCard(c => ({ ...c, link: e.target.value }))} /></div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="a-btn a-btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save Card'}</button>
              <button className="a-btn a-btn-ghost" type="button" onClick={() => setEditCard(null)}>Cancel</button>
            </div>
          </form>
        )}
        {loading ? <div className="admin-spinner">Loading…</div> : (
          cards.map(card => (
            <div key={card.id} className="admin-list-item">
              <img src={card.img} alt={card.title} className="img-preview" />
              <div className="admin-list-item-content">
                <strong>{card.title}</strong>
                <div style={{ fontSize: 13, color: 'var(--a-text-muted)' }}>{card.desc}</div>
              </div>
              <div className="admin-list-item-actions">
                <button className="a-btn a-btn-sm a-btn-ghost" onClick={() => setEditCard(card)}>Edit</button>
                <button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDelete(card.id)}>Delete</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default function AdminHomeContent() {
  return (
    <AdminLayout title="Home Content">
      <IntroSection />
      <WhyChooseSection />
      <InfoCardsSection />
    </AdminLayout>
  );
}
